import { createEntityAdapter, createSlice, EntityState,PayloadAction } from '@reduxjs/toolkit';
import { fetchLicenses } from 'common/services/api/Licenses/Licenses.thunk';
import { ILicensesState,License } from 'common/types/Entities';
import { createMemoizedKeySelector } from 'common/utils/selectorUtils';
import { createStatusDropdownFilterReducers } from 'common/utils/sliceUtils/filterSliceUtils';

type StateWithLicenses = { licenses: EntityState<License, string | number> & ILicensesState };

const licensesAdapter = createEntityAdapter<License, string | number>({ selectId: (item) => item.id });

const initialState = licensesAdapter.getInitialState<ILicensesState>({
    licenses: [],
    licensesByTenantId: {},
    loaded: false,
    filters: {
        keywords: [],
        dropdowns: {
            status: {
                keys: [],
                asKeyword: false
            }
        },
    },
});

const licenseSlice = createSlice({
    name: 'licenses',
    initialState,

    reducers: (create) => ({
        ...createStatusDropdownFilterReducers(initialState),
        clearLicenses: create.reducer((state) => {
            state.licenses = [];
        })
    }),

    extraReducers: builder => {
        builder.addCase(fetchLicenses.pending, state => {
            state.loaded = false;
            state.licenses = [];
        });
        builder.addCase(fetchLicenses.fulfilled, (state, action: PayloadAction<License[]>) => {
            state.loaded = true;
            state.licenses = action.payload;
            if(action.payload.length) {
                const tenantId = action.payload[0].tenantId;
                state.licensesByTenantId =  {
                    ...state.licensesByTenantId,
                    [tenantId]: action.payload
                };
            }
        });
        builder.addCase(fetchLicenses.rejected, state => {
            state.loaded = false;
            state.licenses = [];
        });
    }
});

export const selectFilters = (state: StateWithLicenses) => state.licenses.filters;

// eslint-disable-next-line no-restricted-syntax
export default licenseSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters, checkStatusFilter, clearLicenses } = licenseSlice.actions;
export const selectLicenses = (state: StateWithLicenses) => state.licenses.licenses;

// Base selector for licensesByTenantId state
const selectLicensesByTenantIdState = (state: StateWithLicenses) => state.licenses.licensesByTenantId;

// Memoized parameterized selector - prevents creating new functions on each render
export const selectLicensesByTenantId = createMemoizedKeySelector(selectLicensesByTenantIdState);

export const selectLicenseProcessing = (state: StateWithLicenses) => state.licenses.loaded;
